export { storeFsInit } from './store';
export type { FsStoreSettings } from './types';
export { storeFsInit as default } from './store';
